import { createAction, createAsyncAction } from 'redux-promise-middleware-actions';
import dayjs from 'dayjs';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { globalPageSize } from '../utils/constants';
import { tneAxiosClient } from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_EXPENSES: 'GET_PARTICULAR_EXPENSES',
    GET_NEXT_EXPENSES: 'GET_NEXT_EXPENSES',
    DELETE_CLAIM: 'DELETE_CLAIM'
  }),
  CHANGE_EXPENSES_STATUS: 'CHANGE_EXPENSES_STATUS'
};

const handleAbort = (abortRef) => {
  if (!abortRef) {
    return new AbortController();
  }
  if (abortRef.current) {
    abortRef.current.abort();
  }
  abortRef.current = new AbortController();
  return abortRef.current;
};

const commonGetExpensesRequest = (
  id,
  pageNumber,
  pageSize,
  day,
  month,
  year,
  status,
  claim,
  contractor,
  sortby,
  t,
  isApprover,
  filtersOptions,
  abortRef
) => {
  let basicUrl =
    `v1/${isApprover ? 'get-expenses-by-approverId' : 'expense/dashboard'}` +
    `?userId=${localStorage.getItem('UserId')}` +
    `&PageNumber=${pageNumber || 1}` +
    `&PageSize=${pageSize || globalPageSize}` +
    `&SortBy=${sortby}`;

  if (status && status !== t('common.general.all'))  basicUrl += `&Status=${status}`;
  if (claim && claim !== t('common.general.all'))    basicUrl += `&ClaimName=${claim}`;
  if (month && month !== t('common.general.all'))    basicUrl += `&Month=${month}`;
  if (year && year !== t('common.general.all'))      basicUrl += `&Year=${year}`;
  if (month && !year && filtersOptions?.Years?.length)
    basicUrl += `&Year=${filtersOptions.Years.at(-1).Year}`;
  if (day && day !== t('common.general.all'))
    basicUrl += `&Date=${dayjs(day).format('YYYY-MM-DD')}`;
  if (contractor?.FirstName && contractor?.LastName && contractor !== t('common.general.all'))
    basicUrl += `&FirstName=${contractor.FirstName}&LastName=${contractor.LastName}`;

  const controller = handleAbort(abortRef);

  return tneAxiosClient
    .get(basicUrl, { signal: controller.signal })
    .then((res) => res?.data);
};

export const getExpenses = createAsyncAction(types.GET_EXPENSES, commonGetExpensesRequest);

export const getNextExpenses = createAsyncAction(types.GET_NEXT_EXPENSES, commonGetExpensesRequest);

export const changeExpensesStatus = createAction(
  types.CHANGE_EXPENSES_STATUS,
  (status) => status
);

export const deleteClaim = createAsyncAction(types.DELETE_CLAIM, (id) => {
  return tneAxiosClient.delete(`v1/expense?expenseId=${id}`).then(() => id);
});